import React, { useContext } from 'react';
import styles from './TinyWidgets.module.scss';
import { SFCollapse, SFIcon } from 'sfui';
import {
  InteractiveBox,
  MediaContext,
  TourContext,
  TourTooltip
} from 'ui-smartforce-settings';
import {
  TinyWidgetsContent,
  TinyWidgetTotalsProps
} from './TinyWidgetsContent/TinyWidgetsContent';

const COLLAPSED_SIZE: number = 80;

export interface TourTooltipProps {
  title: string;
  description: string;
  step: number;
  lastStep: number;
  tourId: number;
}
export interface TinyWidgetsProps {
  totals: TinyWidgetTotalsProps[];
  tourTooltipProps?: TourTooltipProps;
}

export const TinyWidgets = ({
  totals,
  tourTooltipProps
}: TinyWidgetsProps): React.ReactElement<TinyWidgetsProps> => {
  const { isMediumScreen } = React.useContext(MediaContext);
  const { onEnd: onTourEnd, setIsFeatureReminderOpen } =
    useContext(TourContext);

  const [isExpanded, setIsExpanded] = React.useState<boolean>(false);

  const onCollapseButtonClick = (): void => {
    setIsExpanded((open) => !open);
  };

  const onTourGotIt = () => {
    onTourEnd();
    setIsFeatureReminderOpen(true);
  };

  return (
    <div className={styles.tinyWidgets}>
      <div className={styles.container}>
        <SFCollapse in={isExpanded} exit collapsedSize={COLLAPSED_SIZE}>
          {tourTooltipProps && (
            <TourTooltip
              title={tourTooltipProps.title}
              description={tourTooltipProps.description}
              step={tourTooltipProps.step}
              lastStep={tourTooltipProps.lastStep}
              tourId={tourTooltipProps.tourId}
              preventOverflow
              placement="bottom"
              onGotIt={onTourGotIt}
            >
              <TinyWidgetsContent totals={totals} />
            </TourTooltip>
          )}
          {!tourTooltipProps && <TinyWidgetsContent totals={totals} />}
        </SFCollapse>
      </div>

      {!isMediumScreen && (
        <InteractiveBox
          className={styles.collapseButton}
          onClick={onCollapseButtonClick}
          role="button"
          aria-label={`${isExpanded ? 'Collapse' : 'Expand'} Fast Facts`}
        >
          <SFIcon icon={isExpanded ? 'Up-2' : 'Down-2'} />
        </InteractiveBox>
      )}
    </div>
  );
};
